import React, { useCallback } from 'react';

import PropTypes from 'prop-types';

import { HeaderGroupPropType, RowPropType } from '../../../../prop-types/react-table';
import { AttributeRow } from '../../items/items-table/items-table-sub-rows/attribute-row';
import { ReactTableWrapper } from 'ui-components/components/react-table-wrapper/react-table-wrapper';

import style from '../../items/items-table/style.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

const ReturnItemsTable = ({ getTableProps, headerGroups = emptyArray, getTableBodyProps, rows = emptyArray, prepareRow }) => {
  return (
    <ReactTableWrapper
      className={style['items-table']}
      getTableBodyProps={getTableBodyProps}
      getTableProps={getTableProps}
      headerGroups={headerGroups}
      headerRowClassName={style['header-row']}
      prepareRow={prepareRow}
      renderSubRow={useCallback(
        (row) => (
          <AttributeRow row={row} />
        ),
        [],
      )}
      rows={rows}
    />
  );
};

export default ReturnItemsTable;

ReturnItemsTable.propTypes = {
  headerGroups: PropTypes.arrayOf(HeaderGroupPropType),
  rows: PropTypes.arrayOf(RowPropType),
  getTableProps: PropTypes.func.isRequired,
  getTableBodyProps: PropTypes.func.isRequired,
  prepareRow: PropTypes.func.isRequired,
};
